import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import './index.scss'
import './styles/rsuite.scss'
import './styles/my_styles.scss'
import './styles/my_ui.scss'

import { store } from './bll/store'
import LoginContainer from './components/login/loginContainer'
import MainContainer from './components/main/mainContainer'
import DisciplinesContainer from './components/disciplines/disciplines.container'
import DisciplineFilesContainer from './components/disciplineFiles/disciplineFiles.container'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
    <BrowserRouter>
        <Provider store={store}>
            <Routes>
                <Route path='/' element={<LoginContainer />} />
                <Route path='/main/*' element={<MainContainer />} />

                <Route path={'/rpd/:id'} element={<DisciplinesContainer />} />
                <Route path={'/rpd/:id/:id'} element={<DisciplineFilesContainer />} />
            </Routes>
        </Provider>
    </BrowserRouter>
)